var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list__item flex items-baseline leading-normal px-6 space-x-6"},[_c('div',{staticClass:"flex-1 py-5 text-center"},[_vm._v("Nothing to see yet!")])])
}]

export { render, staticRenderFns }